module.exports = __webpack_public_path__ + "img/ic_mpe_bed_sm3_press.7802d094.png";